/* SITYA Turbo-Pill Live-State
   Haelt die Gratis-Turbo-Pills (.sitya-turbo-pill) auf Kollektions-/Produktseiten
   sofort aktuell — ohne Hard-Refresh. Der Server rendert den korrekten
   Initialzustand; dieses Script aktualisiert ihn bei Warenkorb-Aenderungen.
   Quelle der Wahrheit: /cart.js — ist der Turbo-Kurs im Warenkorb rabattiert
   (= gratis ueber den BxGY-Automatikrabatt), gilt die Aktion als "aktiviert". */
(function () {
  'use strict';

  function stabilizeMobilePdpPill(el) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    if (!el.closest('.product-information') || el.dataset.sityaPillStable === '1') return;

    var rect = el.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    el.style.minWidth = Math.ceil(rect.width) + 'px';
    el.style.minHeight = Math.ceil(rect.height) + 'px';
    el.dataset.sityaPillStable = '1';
  }

  function updateGratisPrice(el, active) {
    var container = el.closest('[ref="priceContainer"]') || el.parentElement;
    if (!container) return;
    var row = container.querySelector('.sitya-price-row');
    if (!row) return;
    if (active) {
      if (row.querySelector('.sitya-gratis-price')) return;
      var orig = row.querySelector('.price:not(.compare-at-price)');
      if (!orig) return;
      orig.dataset.sityaOrigText = orig.textContent;
      orig.dataset.sityaOrigClass = orig.className;
      var s = document.createElement('s');
      s.className = 'compare-at-price sitya-gratis-s';
      s.textContent = orig.textContent;
      row.insertBefore(s, orig);
      orig.className = 'price price--sale sitya-gratis-price';
      orig.style.color = 'var(--sitya-green,#75b900)';
      orig.textContent = '€ 0,00';
    } else {
      var gp = row.querySelector('.sitya-gratis-price');
      var gs = row.querySelector('.sitya-gratis-s');
      if (!gp || !gs) return;
      gp.className = gp.dataset.sityaOrigClass || 'price';
      gp.style.color = '';
      gp.textContent = gp.dataset.sityaOrigText || '';
      delete gp.dataset.sityaOrigText;
      delete gp.dataset.sityaOrigClass;
      gs.remove();
    }
  }

  function setPill(el, active) {
    stabilizeMobilePdpPill(el);

    var on = el.getAttribute('data-on') || 'Gratis-Turbo aktiviert';
    var off = el.getAttribute('data-off') || 'Gratis-Turbo möglich';
    var txt = el.querySelector('.sitya-turbo-pill__text');
    var want = active ? on : off;
    if (txt) {
      if (txt.textContent !== want) txt.textContent = want;
    } else if (el.textContent !== want) {
      el.textContent = want;
    }
    el.classList.toggle('is-active', !!active);
    updateGratisPrice(el, !!active);
  }

  var inflight = false;
  function refresh() {
    var pills = document.querySelectorAll('.sitya-turbo-pill[data-product-id]');
    if (!pills.length || inflight) return;
    inflight = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var freeIds = {};
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          var isFree = (it.total_discount && it.total_discount > 0) ||
                       it.final_price === 0 || it.final_line_price === 0;
          if (isFree) freeIds[it.product_id] = true;
        }
        for (var p = 0; p < pills.length; p++) {
          var el = pills[p];
          var id = parseInt(el.getAttribute('data-product-id'), 10);
          setPill(el, !!freeIds[id]);
        }
      })
      .catch(function () { /* Server-Render bleibt als Fallback bestehen */ })
      .then(function () { inflight = false; });
  }

  function init() { refresh(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pageshow', refresh);

  /* Bekannte Cart-Events (Horizon/Shopify/Drittanbieter) */
  ['cart:update', 'cart:updated', 'cart:change', 'cart:changed', 'cart:refresh', 'on:cart:update']
    .forEach(function (ev) { document.addEventListener(ev, refresh); });

  /* Fallback: Cart-Drawer-Morph / dynamische DOM-Aenderungen beobachten (debounced) */
  if (window.MutationObserver) {
    var deb;
    new MutationObserver(function () {
      clearTimeout(deb);
      deb = setTimeout(refresh, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
